export const AUTH_QUERY_KEYS = {
  me: ["auth", "me"] as const,
};

export const PASSWORD_MIN_LENGTH = 8;
